// extracted by mini-css-extract-plugin
export default {"color":"Login_color__ASG7k","options":"Login_options__A5aWA","link":"Login_link__bP+Tb"};